export default __webpack_public_path__ + "static/media/Literaspand1.6bdc33b1.jpg";